import axios from 'axios';
import Vue from 'vue';
import xhrRoutes from './routes/xhr';
import modal from './read-more-modal';
import comments from './comments/comments';
import messages from './messages/messages';

export default function () {
  const timelineType = document.querySelector('[data-timeline-type]').getAttribute('data-timeline-type');
  const timelineId = document.querySelector('[data-timeline-id]').getAttribute('data-timeline-id');

  const timeline = new Vue({
    name: 'timeline',
    el: '#js-timeline',
    delimiters: ['#{', '}'],
    data: {
      responseData: [],
      showMoreMessages: false,
      preload: false,
      loading: false,
      lastMessage: false,
    },
    methods: {
      loadTimeline: function () {
        const self = this;
        self.preload = true;
        const data = xhrRoutes.timeline.getTimelineData;

        // Set type
        data.params.type = timelineType;

        // Set Id
        if (data.params.type !== 'personal') {
          data.params[data.params.type] = timelineId;
        }

        axios.get(data.url, {
          params: data.params,
        })
          .then(function (response) {
            self.responseData = response.data.data;
            self.preload = false;

            if (self.responseData.length === 10) {
              self.showMoreMessages = true;
            } else {
              self.lastMessage = true;
            }

            setTimeout(function () {
              comments.init();
              messages.init();
              app.msnry.rebuild();
              modal(self.responseData);
            }, 50);
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      updateTimeline: function () {
        const self = this;
        const data = xhrRoutes.timeline.getTimelineData;
        data.params.offset += data.params.limit;
        self.loading = true;

        axios.get(data.url, {
          params: data.params,
        })
          .then(function (response) {
            if (response.data.data.length < data.params.limit) {
              self.showMoreMessages = false;
              self.lastMessage = true;
            }

            self.loading = false;

            [].forEach.call(response.data.data, (function (element) {
              self.responseData.push(element);
            }));

            setTimeout(function () {
              comments.init();
              messages.init();
              app.msnry.add();
              modal(self.responseData);
            }, 50);
          })
          .catch(function (error) {
            console.log(error);
          });
      },
    },
    mounted: function () {
      const self = this;

      this.$nextTick(function () {
        self.loadTimeline();
      });
    }
  });
};
